import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_ctx.confirmationShown)
    ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
        key: 0,
        acceptTheme: "primary",
        rejectTheme: "return",
        titleText: "Are you sure you want to go back? Any changes made to your Trailer Assessment will erased.",
        subtitleText: "This action cannot be undone!",
        acceptText: "Yes",
        rejectText: "No",
        onAccept: _ctx.goBack,
        onReject: _ctx.returnToTrailerAssessment
      }, null, 8, ["onAccept", "onReject"]))
    : _createCommentVNode("", true)
}